<template>
  <b-card>
    <h3>Violations Aggregations</h3>
    <base-overlay :show="fetching">
      <div class="d-flex justify-content-between">
        <div
          v-for="(value, key, index) in aggs"
          :key="key + index"
          class="d-flex align-items-center"
        >
          <div class="mb-0">
            {{ snakeCaseToCamelCase(key) }}:
          </div>
          <strong>{{ value }}</strong>
        </div>
      </div>
    </base-overlay>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BCard } from 'bootstrap-vue'
import { errorNotification } from '@/utils/toast-notifications'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'

export default {
  components: {
    BCard,
    BaseOverlay,
  },
  setup(props, ctx) {
    const fetching = ref(false)
    const { id } = ctx.root.$route.params

    const aggs = ref()

    const fetchAggs = async () => {
      try {
        fetching.value = true
        const res = await ctx.root.$store.dispatch('drivers/fetchDriverViolationAggs', {
          driverID: id,
        })
        const { data } = res.data
        aggs.value = data
        console.log(res, 'RESULT')
      } catch (error) {
        errorNotification('Failed to fetch driver violation aggs')
      } finally {
        fetching.value = false
      }
    }
    fetchAggs()
    return {
      fetching,
      snakeCaseToCamelCase,
      aggs,
    }
  },
}
</script>
